module.exports = __webpack_public_path__ + "img/visa-dark.8c8bf3b1.svg";